import React, { Suspense } from 'react';

interface Props {
  /**
   * The fallback we'll show on the server and the client.
   */
  fallback: NonNullable<React.ReactElement>;
  children: React.ReactNode;
}

/**
 * Prevents rendering of a Suspense tag during server-side rendering by nakedly rendering the fallback we'd have used for suspense.
 *
 * Only use this if the fallback for server and client are identical.
 */
const SuspenseWithServerFallback = ({
  fallback,
  children,
}: Props): React.ReactElement => {
  if (typeof window === 'undefined') {
    return fallback;
  }
  return <Suspense fallback={fallback}>{children}</Suspense>;
};

SuspenseWithServerFallback.displayName = 'SuspenseWithServerFallback';

export default SuspenseWithServerFallback;
